import React, { Fragment, useEffect, useState } from 'react'
import Subtitle from '../subtitle/Subtitle';
import { Row, Col, Container, Card } from 'reactstrap';
import { Collapse, CardBody, CardHeader } from 'reactstrap';
import EirButton from '../eir-button/EirButton';
import { css } from 'emotion';
import { isMobile, isTablet, isMobileOnly } from "react-device-detect";
import { htmlWidget, LargeBusiness } from '../../Constants';
import IconTextTile from '../icon-text-tile/IconTextTile';

function EirBundleCardTile(props) {
    const renderContent = (content) => {
        return { __html: content };
    }
    useEffect(() => {
        let getParentRef = document.querySelector("#" + props.id);
        //Logic to display same height for all the card-titles  
        if (props.title !== undefined) {
            setTimeout(() => {
                var title = getParentRef.querySelectorAll(".three_six_titlearea");
                var Array = [];

                for (var i = 0; i < title.length; i++) {
                    Array.push(parseInt(title[i].clientHeight));
                }
                for (var i = 0; i < title.length; i++) {
                    //  Adding hidden to the classlist if there is no title in all the tiles.
                    if (Math.max(...Array) == 16) {
                        title[i].classList.add("hidden");
                    }
                    else {
                        if (!isMobileOnly) title[i].style.height = (Math.max.apply(Math, Array) + "px");
                    }
                }
            }, 2000);
        }

        //Logic to display same height for all the card-textarea  
        if (props.text !== undefined) {
            setTimeout(() => {
                var text = getParentRef.querySelectorAll(".three_six_textarea");
                var Array = [];

                for (var i = 0; i < text.length; i++) {
                    Array.push(parseInt(text[i].clientHeight));
                }
                if (!isMobileOnly) {
                    for (var i = 0; i < text.length; i++) {
                        text[i].style.height = (Math.max.apply(Math, Array) + "px");
                    }
                }
            }, 2000);
        }

        //Logic to display same height for all the currency_area.  
        if (props.currency !== undefined) {
            setTimeout(() => {
                var currency = getParentRef.querySelectorAll(".three_six_currency_area");
                var Array = [];

                for (var i = 0; i < currency.length; i++) {
                    Array.push(parseInt(currency[i].clientHeight));
                }
                if (!isMobileOnly) {
                    for (var i = 0; i < currency.length; i++) {
                        currency[i].style.height = (Math.max.apply(Math, Array) + "px");
                    }
                }
            }, 2000);
        }

        //Logic to display same height for all the tiles.  
        if (props !== undefined) {
            setTimeout(() => {
                var content = getParentRef.querySelectorAll(".tile-content");
                var Array = [];

                for (var i = 0; i < content.length; i++) {
                    Array.push(parseInt(content[i].clientHeight));
                }
                if (!isMobileOnly) {
                    for (var i = 0; i < content.length; i++) {
                        content[i].style.height = (Math.max.apply(Math, Array) + "px");
                    }
                }
            }, 2000);
        }
    })

    let plus;
    const [isOpen, setOpen] = (props.enableAccordion != undefined && props.enableAccordion == true) ? ((!isMobileOnly) ? useState(true) : ((props.index != undefined) && (props.index == 0) ? useState(true) : useState(false))) : useState(true);

    if (!isOpen) {
        switch (true) {
            case (window.location.href.indexOf("/business/lb") > 0): {
                plus = <span className="eir-icon eir-icon--sm navigation-icon-lb " />;
                break;
            }
            case (window.location.href.indexOf("/business/") > 0): {
                plus = <span className="eir-icon eir-icon--sm navigation-icon-sb " />;
                break;
            }
            default: {
                plus = <span className="eir-icon eir-icon--sm icon-arrowdown--black float-right" />;
            }
        }
    } else {
        switch (true) {
            case (window.location.href.indexOf("/business/lb") > 0): {
                plus = <span className="eir-icon eir-icon--sm navigation-icon-lb rotate" />;
                break;
            }
            case (window.location.href.indexOf("/business/") > 0): {
                plus = <span className="eir-icon eir-icon--sm navigation-icon-sb rotate" />;
                break;
            }
            default: {
                plus = <span className="eir-icon eir-icon--sm icon-arrowdown--black float-right rotate" />;
            }
        }

    }

const hasTitleContent = title => {
    if (!title) return false;

    const text = title
        .replace(/<[^>]*>/g, '')
        .replace(/&nbsp;/gi, '')
        .replace(/\u00A0/g, '')
        .replace(/�/g, '')
        .trim();

    return text.length > 0;
};
    
    return (
    <div className={`business-general-tile `} >
            <div className="business-general-tile-body">
                <a href={(props.cta && (props.cta.type == 'arrow' || props.cta.type == '')) && props.cta.link}>
                    {props.image &&
                        <div>
                            <div className='tile-content'>
                                <div className='d-flex'>
                                    {hasTitleContent(props.title) && <span className={htmlWidget + '  three_six_titlearea w-100 bundle-card-title-ipad-spec ' + (!isMobileOnly ? 'mt-4 mb-2' : 'mt-3 ')} onClick={() => isMobileOnly && props.enableAccordion && setOpen(!isOpen)} dangerouslySetInnerHTML={renderContent(props.title)} />}
                                    {props.enableAccordion != undefined && props.enableAccordion && <span className={(isMobileOnly) ? 'mr-2 icon' : 'd-none'} onClick={() => props.enableAccordion && setOpen(!isOpen)}  >{plus}</span>
                                    }
                                </div>
                                <Collapse isOpen={isOpen}>
                                    <div >
                                        {props.image &&
                                        <div className="p-0 bundle-card-image-container">
                                                <div className="d-flex flex-column justify-content-center align-items-center">
                                                    <img className="w-100 mb-2 top-borders shadow-none" src={props.image} alt={props.alt} />
                                                </div>
                                            </div>
                                        }
                                        {
                                            LargeBusiness.isLBSite ? (
                                                <div className='bundle-text-contents'>
                                                    {props.iconTextTiles ?
                                                        props.iconTextTiles.map((iconTextTile) => <IconTextTile iconText={iconTextTile} />) : ""}
                                                    <div className={htmlWidget + ' three_six_currencyarea'} dangerouslySetInnerHTML={renderContent(props.currency)} ></div>
                                                </div>)
                                                :
                                                (<Fragment>
                                                    {props.text &&
                                                        <Subtitle className='eir-text justify-content-center ml-3  mr-3 three_six_textarea text-body' text={props.text} />
                                                    }
                                                    <div className='three_six_currencyarea' dangerouslySetInnerHTML={renderContent(props.currency)} ></div>

                                                </Fragment>)
                                        }

                                    </div>
                                </Collapse>
                            </div>
                        </div>
                        }
                </a>

            </div>
        </div>
    )
}
export default EirBundleCardTile;